export const hasLocalStorage =
  typeof window !== "undefined" && window.localStorage;
export const storageNameSpace = "poser";
